import { Helmet } from "react-helmet";
import { useLocation } from "react-router";
import { getContainer } from "../ioc/IOCSetup";
import {Route, Switch} from "react-router-dom";
import {SportsbookProvider} from "../http/protocol";
import * as React from "react";

export const HeaderContributor = (props: { canonicalBaseUrl: string; locale?: string }) => {
     const location = useLocation();
     const { pathname } = location;
     const settingsService = getContainer().getSettingsService();
     const alternateLang = settingsService
          .getLocalesData()
          .map(({ code }) => code)
          .filter((code) => code !== props.locale);

    return (
        <>
            <Switch>
                {/* custom header contributor for these */}
                <Route exact path="/casino/play/:gameId/:provider"></Route>
                <Route exact path="/casino/play/:gameId/:provider/:mode"></Route>
                <Route path={"/"}>
                    <Helmet>
                        <link rel={"canonical"}
                              href={props.canonicalBaseUrl + (props.locale ? `/${props.locale}` : "") + (pathname ? pathname : "")}/>
                        {alternateLang.map((lang) => (
                            <link rel={"alternate"}
                                  href={props.canonicalBaseUrl + `/${lang}` + (pathname ? pathname : "")}
                                  hrefLang={lang}/>
                        ))}
                        <link rel={"alternate"} href={props.canonicalBaseUrl + (pathname ? pathname : "")}
                              hrefLang="x-default"/>
                    </Helmet>
                </Route>
            </Switch>
        </>
    )
};
